import { $font_size_h6 } from '../pebbleGlobalToken/font.js';

/**
 * 对话框-标题字体的字号。
 * @description enDesc: -
 * @description type: Font
 * @description value: 16
 */
var $modal_title_font_size = $font_size_h6;

export { $modal_title_font_size };
